import { axios } from "@bundled-es-modules/axios";
import { LitElement, html, css } from "lit-element";
import { repeat } from "lit-html/directives/repeat.js";
import { classMap } from "lit-html/directives/class-map";

class PaymentComponent extends LitElement {
  static get properties() {
    return {
      _ReceiptHeader: { type: String },
      _ReceiptThankYouText: { type: String },
      _ReceiptConfirmationText: { type: String },
      _ReceiptLogo: { type: String },
      _ReceiptLinkText: { type: String },
      _ReceiptLink: { type: String },
      _MainServiceDomain: { type: String },
      _loginDetails: { type: Object },
      _userDetails: { type: Object },
      _makePayment: { type: Boolean },
      _paymentAmount: { type: Number },
      _carrierTip: { type: Number },
      _nieDonation: { type: Number },
      _totalValue: { type: Number },
      _subscriptionDetails: { type: Object },
      paymentDetails: { type: Boolean },
      _paymentErrorMessage: { type: String },
      monthList: { type: Array },
      selectedMonth: { type: Object },
      yearList: { type: Array },
      selectedYear: { type: Object },
      _edgilPaymentConfig: { type: Object },
      _requestToken: { type: String },
      _firstNameOnCard: { type: String },
      _lastNameOnCard: { type: String },
      _paywayWSAddAccountResults: { type: Object },
      _creditCardList: { type: Array },
      _confirmPayment: { type: Boolean },
      _finalPaymentDetails: { type: Object },
      _newsLink: { type: String },
      _print: { type: Boolean },
    };
  }

  get ReceiptHeader() {
    return this._ReceiptHeader;
  }

  set ReceiptHeader(value) {
    this._ReceiptHeader = value;
  }

  get ReceiptThankYouText() {
    return this._ReceiptThankYouText;
  }

  set ReceiptThankYouText(value) {
    this._ReceiptThankYouText = value;
  }

  get ReceiptConfirmationText() {
    return this._ReceiptConfirmationText;
  }

  set ReceiptConfirmationText(value) {
    this._ReceiptConfirmationText = value;
  }

  get ReceiptLogo() {
    return this._ReceiptLogo;
  }

  set ReceiptLogo(value) {
    this._ReceiptLogo = value;
  }

  get ReceiptLinkText() {
    return this._ReceiptLinkText;
  }

  set ReceiptLinkText(value) {
    this._ReceiptLinkText = value;
  }

  get ReceiptLink() {
    return this._ReceiptLink;
  }

  set ReceiptLink(value) {
    this._ReceiptLink = value;
  }

  get MainServiceDomain() {
    return this._MainServiceDomain;
  }

  set MainServiceDomain(value) {
    this._MainServiceDomain = value;
  }

  get loginDetails() {
    return this._loginDetails;
  }

  set loginDetails(value) {
    this._loginDetails = value;
  }

  get userDetails() {
    return this._userDetails;
  }

  set userDetails(value) {
    this._userDetails = value;
  }

  get makePayment() {
    return this._makePayment;
  }

  set makePayment(value) {
    this._makePayment = value;
  }

  get paymentAmount() {
    return this._paymentAmount;
  }

  set paymentAmount(value) {
    this._paymentAmount = value;
  }

  get carrierTip() {
    return this._carrierTip;
  }

  set carrierTip(value) {
    this._carrierTip = value;
  }

  get nieDonation() {
    return this._nieDonation;
  }

  set nieDonation(value) {
    this._nieDonation = value;
  }

  get totalValue() {
    return this._totalValue;
  }

  set totalValue(value) {
    this._totalValue = value;
  }

  get subscriptionDetails() {
    return this._subscriptionDetails;
  }

  set subscriptionDetails(value) {
    this._subscriptionDetails = value;
  }

  get paymentErrorMessage() {
    return this._paymentErrorMessage;
  }

  set paymentErrorMessage(value) {
    this._paymentErrorMessage = value;
  }

  get edgilPaymentConfig() {
    return this._edgilPaymentConfig;
  }

  set edgilPaymentConfig(value) {
    this._edgilPaymentConfig = value;
  }

  get requestToken() {
    return this._requestToken;
  }

  set requestToken(value) {
    this._requestToken = value;
  }

  get firstNameOnCard() {
    return this._firstNameOnCard;
  }

  set firstNameOnCard(value) {
    this._firstNameOnCard = value;
  }

  get lastNameOnCard() {
    return this._lastNameOnCard;
  }

  set lastNameOnCard(value) {
    this._lastNameOnCard = value;
  }

  get paywayWSAddAccountResults() {
    return this._paywayWSAddAccountResults;
  }

  set paywayWSAddAccountResults(value) {
    this._paywayWSAddAccountResults = value;
  }

  get creditCardList() {
    return this._creditCardList;
  }

  set creditCardList(value) {
    this._creditCardList = value;
  }

  get confirmPayment() {
    return this._confirmPayment;
  }

  set confirmPayment(value) {
    this._confirmPayment = value;
  }

  get finalPaymentDetails() {
    return this._finalPaymentDetails;
  }

  set finalPaymentDetails(value) {
    this._finalPaymentDetails = value;
  }

  get newsLink() {
    return this._newsLink;
  }

  set newsLink(value) {
    this._newsLink = value;
  }

  get isPrint() {
    return this._print;
  }

  set isPrint(value) {
    this._print = value;
  }

  constructor() {
    super();
    this.print = false;
    this.makePayment = false;
    this.paymentAmount = 0;
    this.carrierTip = 0;
    this.nieDonation = 0;
    this.totalValue = 0;
    this.paymentDetails = false;
    this.confirmPayment = false;
    this.monthList = [
      { name: "Jan", code: "01" },
      { name: "Feb", code: "02" },
      { name: "Mar", code: "03" },
      { name: "Apr", code: "04" },
      { name: "May", code: "05" },
      { name: "Jun", code: "06" },
      { name: "Jul", code: "07" },
      { name: "Aug", code: "08" },
      { name: "Sep", code: "09" },
      { name: "Oct", code: "10" },
      { name: "Nov", code: "11" },
      { name: "Dec", code: "12" },
    ];

    this.yearList = [
      { name: "2025", code: "25" },
      { name: "2026", code: "26" },
      { name: "2027", code: "27" },
      { name: "2028", code: "28" },
      { name: "2029", code: "29" },
      { name: "2030", code: "30" },
      { name: "2031", code: "31" },
      { name: "2032", code: "32" },
      { name: "2033", code: "33" },
      { name: "2034", code: "34" },
      { name: "2035", code: "35" },
      { name: "2036", code: "36" },
      { name: "2037", code: "37" },
      { name: "2038", code: "38" },
      { name: "2039", code: "39" },
    ];
    document.addEventListener("onSelectSubscription", async (e) => {
      this.loginDetails = e.detail.loginDetails;
      this.userDetails = e.detail.userDetails;
      this.subscriptionDetails = e.detail.selectedSubscription;
    });
  }

  static get styles() {
    return css`
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      .disabled {
        opacity: 0.5;
        pointer-events: none;
        cursor: not-allowed;
        position: relative;
      }

      .text-center {
        text-align: center !important;
      }

      .text-right {
        text-align: right !important;
      }

      .d-none {
        display: none;
      }

      .d-block {
        display: block;
      }

      .d-flex {
        display: flex;
      }
      .w-50 {
        width: 50%;
      }

      .justify-content-between {
        justify-content: space-between;
      }

      .align-items-center {
        align-items: center;
      }

      .w-100 {
        width: 100%;
      }

      .h-100 {
        height: 100%;
      }

      .w-250 {
        width: 250px;
      }

      .mg-b5 {
        margin-bottom: 5px !important;
      }

      .mg-t5 {
        margin-top: 5px !important;
      }

      .mg-r20 {
        margin-right: 20px !important;
      }

      .pd-lr5 {
        padding-left: 5px !important;
        padding-right: 5px !important;
      }

      p {
        font-size: 13px;
      }

      .font-bold {
        font-weight: 700;
      }

      .min-width95 {
        min-width: 95px;
      }
      /* Element Style */
      .payment-box {
        border-radius: 35px;
        position: relative;
        padding: 25px 25px;
        width: 100%;
        border: 1px solid var(--w-bg-borc, #505050);
        background-color: var(--w-bgc, #fff);
        box-sizing: border-box;
      }

      .payment-heading {
        font-size: var(--w-tit-fs, 14px);
        color: var(--w-tit-col, #000);
        background-color: var(--w-tit-bgc, #fff);
        padding: 10px;
        border-radius: 5px;
      }

      .payment-error {
        font-size: 14px;
        color: var(--payment-heading-Color, #000);
        background-color: var(--payment-heading-bgColor, #fff);
        border: 1px solid var(--payment-heading-borderColor, #505050);
        padding: 10px;
        border-radius: 5px;
      }

      .error {
        font-size: var(--w-msg-fs, 13px);
        color: var(--w-msg-col, #000);
      }

      .cdapress-heading {
        font-size: 14px;
        color: var(--cdapress-heading-Color, #000);
        padding: 10px;
        border-radius: 5px;
      }

      .cdapress {
        list-style: none;
        width: 100%;
      }

      .cda-box {
        display: flex;
        align-items: center;
      }

      .cda-right {
        width: 65%;
      }

      .cds-left {
        width: 35%;
      }

      .sub-Accountdetail {
        font-size: 12px;
        color: var(--sub-Accountdetail-Color, #000);
        padding: 10px;
      }

      .btn {
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid transparent;
        padding: 6px 12px;
        font-size: 16;
        line-height: 1.5;
        border-radius: 4px;
      }

      .btn:hover,
      .btn:focus {
        text-decoration: none;
      }

      .btn:focus,
      .btn.focus {
        outline: 0;
        box-shadow: none;
      }

      .btn.disabled,
      .btn:disabled {
        opacity: 0.65;
      }

      .btn-success {
        color: var(--w-btn-col, #505050);
        background-color: var(--w-btn-bgc, #fff);
        border: 1px solid var(--w-btn-borc, #505050);
        font-size: var(--w-btn-fs, 14px);
        cursor: pointer;
      }

      .btn-success:hover {
        color: var(--w-btn-col, #fff);
        background-color: var(--w-btn-bgc, #505050);
        border: 1px solid var(--w-btn-borc, #505050);
        font-size: var(--w-btn-fs, 14px);
        cursor: pointer;
      }

      .btn-lg {
        padding: 8px 16px;
        font-size: var(--w-btn-fs, 14px);
        line-height: 1.5;
        border-radius: 4px;
        word-break: break-word;
        white-space: normal;
      }

      .btn-block {
        display: block;
        width: 100%;
      }

      .form-group {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-bottom: 0;
        color: var(--form-group-color, #fff);
      }

      label {
        text-align: left;
        font-size: 14px;
        color: var(--label-color, #000);
      }

      .form-control {
        display: block;
        width: 100%;
        padding: 8px 12px;
        font-size: 14px;
        line-height: 1.5;
        color: var(--form-control-color, #000);
        background-color: var(--form-control-bgColor, #fff);
        border: 1px solid var(--form-control-borderColor, #505050);
        background-clip: padding-box;
        border-radius: 4px;
      }

      .form-control:focus {
        color: var(--form-control-focus-color, #495057);
        background-color: var(--form-control-focus-bgColor, #fff);
        border-color: var(--form-control-borderColor, #505050);
        outline: 0;
        box-shadow: 0 0 0 0.2rem
          var(--form-control-focus-boxShadow, rgba(65, 157, 255, 0.25));
      }

      .form-control::-webkit-input-placeholder {
        color: var(--form-control-placehorderColor, #959595);
        opacity: 1;
      }

      .form-control::-moz-placeholder {
        color: var(--form-control-placeholderColor, #959595);
        opacity: 1;
      }

      .form-control:-ms-input-placeholder {
        color: var(--form-control-placeholderColor, #959595);
        opacity: 1;
      }

      .form-control::-ms-input-placeholder {
        color: var(--form-control-placeholderColor, #959595);
        opacity: 1;
      }

      .form-control::placeholder {
        color: var(--form-control-placeholderColor, #959595);
        opacity: 1;
      }

      .dropdown {
        width: 100%;
        position: relative;
      }

      /*List*/
      .header-dropdown-btn {
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        padding-left: 3px;
        font-size: 14px;
        overflow: hidden;
      }

      .dropdown-toogle {
        width: 100%;
        display: block;
        padding: 10px 0;
        border-radius: 5px;
        background-color: var(--dropdown-button-bgColor, #fff);
        color: var(--dropdown-button-Color, #000);
        border: 1px solid var(--dropdown-button-borderColor, #505050);
        font-size: var(--w-txt-fs, 14px);
        cursor: pointer;
      }

      .dropdown-toogle:focus {
        outline: none;
        box-shadow: none;
      }

      .dropdown-list {
        color: var(--dropdown-list-color, #000);
        background-color: var(--dropdown-list-bgColor, #fff);
        border: 1px solid var(--dropdown-list-borderColor, #505050);
        list-style: none;
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        border-radius: 0 0 4px 4px;
        margin-top: -5px;
        z-index: 10;
      }

      .dropdown-item {
        padding: 5px;
        cursor: pointer;
        font-size: var(--w-txt-fs, 14px);
      }

      .dropdown-item:hover {
        background-color: var(--widget-background-bgColor, #000);
        color: #fff;
        cursor: pointer;
      }

      .dropdown-item.active {
        background-color: var(--widget-background-bgColor, #000);
        color: #fff;
      }

      .button-arrow {
        position: relative;
        padding: 4px 16px 4px 5px;
      }

      .button-arrow::before {
        content: " ";
        position: absolute;
        display: inline-block;
        transform: rotate(45deg);
        right: 10px;
        top: 8px;
        border-style: solid;
        border-width: 0px 1px 1px 0px;
        padding: 3px;
      }
      .card-expire-title {
        font-size: var(--w-tit-fs, 14px);
        color: #000;
        background-color: #fff;
        padding: 10px;
        border-radius: 5px;
      }
      .card-expiration {
        display: flex;
        width: 100%;
        justify-content: flex-end;
      }
      .card-exp-dropdown {
        width: 80px;
      }
      .card-exp-droplist {
        height: 80px;
        overflow-y: auto;
      }
      .payment-succ-btnBox {
        margin: 0 -5px;
      }
      .payment-succ-btn {
        padding: 0 5px;
        width: 50%;
      }

      @media print {
        .cdapress {
          width: 100% !important;
          list-style: none !important;
        }
        .cda-box {
          display: flex !important;
          align-items: center !important;
        }
        .sub-Accountno {
          color: red !important;
        }
      }
      @media (max-width: 767px) {
        .payment-box {
          padding: 15px;
          border-radius: 20px;
        }
      }
    `;
  }

  render() {
    return html` <div
      class=${classMap({
        "payment-box": true,
        disabled: this.subscriptionDetails
          ? this.subscriptionDetails.Status === "Inactive"
          : false,
      })}>
      ${!this.paymentDetails
        ? html`<div class="text-center mg-b5">
              <h2 class="payment-heading">Need to make a payment?</h2>
            </div>
            ${this.makePayment
              ? html`<div class="payment-expand-div d-block mg-b5">
                  <p class="mg-t5 text-center mg-b5">
                    Select your payment amount, enter any tip or donation and
                    click continue to enter your credit card information
                  </p>
                  <div class="text-center form-group mg-b5">
                    <label class="mg-b5">Payment Amount</label>
                    <input
                      id="payment-amount"
                      type="number"
                      class="form-control"
                      min="0"
                      @input=${this.getTotalPaymentValue}
                      @change=${this.formatOnChange}
                      value=${this.formatNumber(this.paymentAmount)} />
                  </div>
                  <div class="text-center form-group mg-b5">
                    <label class="mg-b5">Carrier Tip</label>
                    <input
                      id="carrier-tip"
                      type="number"
                      class="form-control"
                      min="0"
                      @input=${this.getTotalPaymentValue}
                      @change=${this.formatOnChange}
                      value=${this.formatNumber(this.carrierTip)} />
                  </div>
                  <div class="text-center form-group mg-b5">
                    <label class="mg-b5">N.I.E Donation</label>
                    <input
                      id="nieDonation"
                      type="number"
                      class="form-control"
                      min="0"
                      @input=${this.getTotalPaymentValue}
                      @change=${this.formatOnChange}
                      value=${this.formatNumber(this.nieDonation)} />
                  </div>
                  <div
                    class="paymnet-total d-flex justify-content-between mg-t5 mg-b5">
                    <p class="font-bold">Total Amount</p>
                    <span class="font-bold">$${this.totalValue}</span>
                  </div>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-success btn-lg min-width95 mg-t5"
                      @click=${this.onAddPaymentDetails}>
                      Continue
                    </button>
                  </div>
                  <p class="text-center">${this.paymentErrorMessage}</p>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-success btn-lg min-width95 mg-t5"
                      @click=${this.cancelPayment}>
                      Cancel
                    </button>
                  </div>
                </div>`
              : html`<button
                    type="submit"
                    class="btn btn-success btn-lg btn-block mg-b5"
                    @click=${this.addAmount}>
                    Make Payment
                  </button>
                  <p class="text-center">${this.paymentErrorMessage}</p>`}`
        : this.confirmPayment
        ? html`<div>
            <p class="text-center">
              We have processed your payment successfully!
            </p>
            <div>
              <p class="text-center mg-b5">
                Confimation #${this.finalPaymentDetails.authorizationCode}
              </p>
              <div class="mg-t5">
                <p class="text-center">
                  Processed Date
                  ${this.dateFormat(
                    this.finalPaymentDetails.transactionDateTime
                  )}
                </p>
                <p class="text-center">
                  Account Number ${this.getAccountNumber()}
                </p>
              </div>
              <div class="payment-info-section">
                <h2 class="cdapress-heading">Payment Information</h2>
                <div class="cdapress">
                  <div class="cda-box">
                    <div class="w-50">
                      <p class="sub-Accountno">Amount of payment</p>
                    </div>
                    <div class="w-50">
                      <p class="sub-Accountdetail text-right">
                        $${this.formatNumber(
                          this.finalPaymentDetails.paymentAmount +
                            this.finalPaymentDetails.tipAmount +
                            this.finalPaymentDetails.donationAmount
                        )}
                      </p>
                    </div>
                  </div>
                  <div class="cda-box">
                    <div class="w-50">
                      <p class="sub-Accountno">Date of payment</p>
                    </div>
                    <div class="w-50">
                      <p class="sub-Accountdetail text-right">
                        ${this.dateFormat(
                          this.finalPaymentDetails.transactionDateTime
                        )}
                      </p>
                    </div>
                  </div>
                  <div class="cda-box">
                    <div class="w-50">
                      <p class="sub-Accountno">Name on card</p>
                    </div>
                    <div class="w-50">
                      <p class="sub-Accountdetail text-right">
                        ${this.paywayWSAddAccountResults.cardAccount.firstName}
                        ${this.paywayWSAddAccountResults.cardAccount.lastName}
                      </p>
                    </div>
                  </div>
                  <div class="cda-box">
                    <div class="w-50">
                      <p class="sub-Accountno">Card number</p>
                    </div>
                    <div class="w-50">
                      <p class="sub-Accountdetail text-right">
                        ${this.paywayWSAddAccountResults.cardAccount
                          .accountNumber}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="text-center mg-t5">Thank you for subscribing!</p>
            </div>
            <div class="text-center payment-succ-btnBox d-flex mg-t5">
              <div class="payment-succ-btn">
                <button
                  type="submit"
                  class="btn btn-success btn-lg w-100 h-100 mg-t5"
                  @click=${this.returnToNews}>
                  Return to the news
                </button>
              </div>
              <div class="payment-succ-btn">
                <button
                  type="submit"
                  class="btn btn-success btn-lg w-100 h-100 mg-t5"
                  @click=${this.printReceipt}>
                  Print
                </button>
              </div>
            </div>
            <div class="text-center mg-t5">
              <button
                type="submit"
                class="btn btn-success btn-lg min-width95 mg-t5"
                @click=${this.closeOnConfirmPayment}>
                Close
              </button>
            </div>
          </div>`
        : html`
            <div class="payment-expand-div d-block mg-b5">
              <h2 class="card-expire-title mg-t5 text-center mg-b5">
                Add payment details here...
              </h2>
              <div class="d-flex justify-content-between mg-t5 mg-b5">
                <p class="font-bold">Total Amount</p>
                <span class="font-bold">$${this.totalValue}</span>
              </div>
              <div class="text-center form-group mg-b5">
                <label class="mg-b5">Name on Card</label>
                <input
                  id="name-on-card"
                  type="text"
                  class="form-control"
                  @change=${this.getName} />
              </div>
              <div class="text-center form-group mg-b5">
                <label class="mg-b5">Card Number</label>
                <input
                  id="card-number"
                  type="text"
                  class="form-control"
                  pattern="^[0-9]{15,16}$" />
              </div>
              <div
                class="payment-total d-flex align-items-center justify-content-between mg-t5 mg-b5">
                <label class="w-250">Card security code</label>
                <input
                  id="card-security-code"
                  type="password"
                  class="form-control" />
              </div>
              <div class="form-group mg-b5">
                <label class="mg-b5">Card expiration Date</label>
                <div class="card-expiration">
                  <div class="dropdown card-exp-dropdown mg-r20 mg-t5">
                    <button
                      type="submit"
                      class="dropdown-toogle header-dropdown-btn button-arrow"
                      @click="${this.showMonths}">
                      ${this.displayMonthSelected()}<i
                        class="fa fa-chevron-down"></i>
                    </button>
                    ${this.monthList
                      ? html`<ul
                          id="months-list"
                          class="dropdown-list card-exp-droplist d-none">
                          ${repeat(
                            this.monthList,
                            (item, index) =>
                              html`<li
                                class="dropdown-item"
                                @click="${this.onSelectedMonth}">
                                ${item.name}
                              </li>`
                          )}
                        </ul>`
                      : html``}
                  </div>
                  <div class="dropdown card-exp-dropdown mg-t5">
                    <button
                      type="submit"
                      class="dropdown-toogle header-dropdown-btn button-arrow"
                      @click="${this.showYears}">
                      ${this.displayYearSelected()}<i
                        class="fa fa-chevron-down"></i>
                    </button>
                    ${this.yearList
                      ? html`<ul
                          id="years-list"
                          class="dropdown-list card-exp-droplist d-none">
                          ${repeat(
                            this.yearList,
                            (item, index) =>
                              html`<li
                                class="dropdown-item"
                                @click="${this.onSelectedYear}">
                                ${item.name}
                              </li>`
                          )}
                        </ul>`
                      : html``}
                  </div>
                </div>
              </div>
              <div class="text-center form-group mg-b5">
                <label class="mg-b5">Zip Code</label>
                <input
                  id="zip-code"
                  type="text"
                  class="form-control"
                  pattern="^[0-9]{5}$" />
              </div>
              <div class="text-center">
                <button
                  type="submit"
                  class="btn btn-success btn-lg min-width95 mg-t5"
                  @click=${this.onConfirmPayment}>
                  Continue
                </button>
              </div>
              <p class="text-center">${this.paymentErrorMessage}</p>
              <div class="text-center">
                <button
                  type="submit"
                  class="btn btn-success btn-lg min-width95 mg-t5"
                  @click=${this.onCancelConfirmPayment}>
                  Cancel
                </button>
              </div>
              <div></div>
            </div>
          `}
      ${this.isPrint
        ? html`<div class="d-none" id="payment-info-div">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td style="text-align:center; padding: 5px;">
                  <img
                    src=${this.ReceiptLogo}
                    alt=""
                    style="width: 300px; display: inline-block;" />
                </td>
              </tr>
              <tr>
                <td style="text-align:center; padding: 5px;">
                  <p
                    style="font-size: 14px; line-height: 18px; color: #a6a6a6; margin-top: 0px; margin-bottom: 10px;">
                    ${this.ReceiptThankYouText}
                  </p>
                </td>
              </tr>
              <tr>
                <td style="padding: 5px;">
                  <p
                    style="font-size: 14px; line-height: 18px; color: #a6a6a6; margin-top: 0px; margin-bottom: 10px;">
                    ${this.ReceiptConfirmationText}.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0">
                    <tr>
                      <td
                        style="width: 70%; padding: 5px; border-top: 1px solid #000;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000; text-transform: uppercase; margin-top: 0px; margin-bottom: 0px;">
                          <strong>ITEM</strong>
                        </p>
                      </td>
                      <td
                        style="width: 30%; padding: 5px; border-top: 1px solid #000;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000; text-transform: uppercase; margin-top: 0px; margin-bottom: 0px;">
                          <strong>AMOUNT</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="width: 70%; padding: 5px; border-top: 2px solid #000; background-color: #cccccc;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000; margin-top: 0px; margin-bottom: 0px;">
                          ${this.subscriptionDetails.Name}
                        </p>
                      </td>
                      <td
                        style="width: 30%; padding: 5px; border-top: 2px solid #000; background-color: #cccccc;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000; margin-top: 0px; margin-bottom: 0px;">
                          $${this.formatNumber(
                            this.finalPaymentDetails.paymentAmount
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 70%; padding: 5px;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000; margin-top: 0px; margin-bottom: 0px;">
                          NIE Donation
                        </p>
                      </td>
                      <td style="width: 30%; padding: 5px;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000; margin-top: 0px; margin-bottom: 0px;">
                          $${this.formatNumber(
                            this.finalPaymentDetails.donationAmount
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="width: 70%; padding: 5px; border-bottom: 2px solid #000; background-color: #cccccc;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000; margin-top: 0px; margin-bottom: 0px;">
                          Carrier Tip
                        </p>
                      </td>
                      <td
                        style="width: 30%; padding: 5px; border-bottom: 2px solid #000; background-color: #cccccc;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000; margin-top: 0px; margin-bottom: 0px;">
                          $${this.formatNumber(
                            this.finalPaymentDetails.tipAmount
                          )}
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td style="padding: 5px;">
                  <p
                    style="font-size: 24px; line-height: 30px; color: #563063; margin-top: 20px; margin-bottom: 0px;">
                    <strong>Payment Information</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0">
                    <tr>
                      <td style="padding: 5px; width: 50%;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px; margin-bottom: 0px;">
                          Amount of payment
                        </p>
                      </td>
                      <td style="padding: 5px; width: 50%;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px; margin-bottom: 0px;">
                          $${this.formatNumber(
                            this.finalPaymentDetails.paymentAmount +
                              this.finalPaymentDetails.tipAmount +
                              this.finalPaymentDetails.donationAmount
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 5px; width: 50%;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px; margin-bottom: 0px;">
                          Date of payment
                        </p>
                      </td>
                      <td style="padding: 5px; width: 50%;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px; margin-bottom: 0px;">
                          ${this.dateFormat(
                            this.finalPaymentDetails.transactionDateTime
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 5px; width: 50%;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px; margin-bottom: 0px;">
                          Name of card
                        </p>
                      </td>
                      <td style="padding: 5px; width: 50%;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px; margin-bottom: 0px;">
                          ${this.paywayWSAddAccountResults.cardAccount
                            .firstName}
                          ${this.paywayWSAddAccountResults.cardAccount.lastName}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 5px; width: 50%;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px; margin-bottom: 0px;">
                          Card number
                        </p>
                      </td>
                      <td style="padding: 5px; width: 50%;">
                        <p
                          style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px; margin-bottom: 0px;">
                          ${this.paywayWSAddAccountResults.cardAccount
                            .accountNumber}
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td style="padding: 5px;">
                  <p
                    style="font-size: 14px; line-height: 18px; color: #000000; margin-top: 20px; margin-bottom: 0px;">
                    ${this.ReceiptLinkText} <a href="">${this.ReceiptLink}</a>
                  </p>
                </td>
              </tr>
            </table>
          </div>`
        : html``}
    </div>`;
  }

  formatNumber(num) {
    return (Math.round(num * 100) / 100).toFixed(2);
  }

  formatOnChange(field) {
    field.target.value = this.formatNumber(field.target.value);
  }

  dateFormat(inputDate) {
    let date = new Date(inputDate);
    inputDate = new Date(inputDate);

    date.setMonth(inputDate.getUTCMonth(), inputDate.getUTCDate());
    date.setFullYear(inputDate.getUTCFullYear());
    date.setHours(inputDate.getUTCHours());
    date.setMinutes(inputDate.getUTCMinutes());
    date.setSeconds(inputDate.getUTCSeconds());
    date.setMilliseconds(inputDate.getUTCMilliseconds());

    const formattedDate = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;
    return formattedDate;
  }

  showMonths() {
    if (this.monthList) {
      const list = this.shadowRoot.getElementById("months-list");

      if (!list.classList.contains("d-none")) {
        list.classList.add("d-none");
      } else {
        list.classList.remove("d-none");
      }
    }
  }

  displayMonthSelected() {
    if (!this.selectedMonth) {
      return "mm";
    }
    return this.selectedMonth.name;
  }

  onSelectedMonth(idx) {
    const month = idx.target.innerText;
    this.selectedMonth = this.monthList.find((i) => i.name === month);
    this.shadowRoot.getElementById("months-list").classList.add("d-none");
  }

  showYears() {
    if (this.yearList) {
      const list = this.shadowRoot.getElementById("years-list");

      if (!list.classList.contains("d-none")) {
        list.classList.add("d-none");
      } else {
        list.classList.remove("d-none");
      }
    }
  }

  displayYearSelected() {
    if (!this.selectedYear) {
      return "yyyy";
    }
    return this.selectedYear.name;
  }

  onSelectedYear(idx) {
    const year = idx.target.innerText;
    this.selectedYear = this.yearList.find((i) => i.name === year);
    this.shadowRoot.getElementById("years-list").classList.add("d-none");
  }

  async addAmount() {
    if (!this.subscriptionDetails) {
      this.paymentErrorMessage = "Please select a subscription";
      return;
    }
    try {
      const header = {
        Authorization: `Bearer ${this.loginDetails.token}`,
      };

      const res = await axios.get(
        `${this.MainServiceDomain}/appservices/api/v2/config/payment/edgil`,
        {
          headers: header,
        }
      );

      if (res.data.paywayWSEndpoint) {
        this.edgilPaymentConfig = res.data;
        this.paymentErrorMessage = "";
        this.makePayment = true;
        const res1 = await this.getCreditCardTypes();
        if (res1.length > 0) {
          this.creditCardList = res1;
        }
      } else {
        this.paymentErrorMessage = "Something went wrong.";
      }
    } catch (error) {
      this.paymentErrorMessage = "Something went wrong.";
    }
  }

  async getCreditCardTypes() {
    try {
      const header = {
        Authorization: `Bearer ${this.loginDetails.token}`,
      };

      const res = await axios.get(
        `${this.MainServiceDomain}/appservices/api/v2/creditcardtypes`,
        {
          headers: header,
        }
      );

      return res.data;
    } catch (error) {
      return error;
    }
  }

  cancelPayment() {
    this.makePayment = false;
    this.paymentAmount = 0.0;
    this.carrierTip = 0.0;
    this.nieDonation = 0.0;
    this.totalValue = 0.0;
    this.paymentErrorMessage = "";
  }

  getTotalPaymentValue() {
    this.paymentAmount = Number(
      this.shadowRoot.getElementById("payment-amount").value
    );
    this.nieDonation = Number(
      this.shadowRoot.getElementById("nieDonation").value
    );
    this.carrierTip = Number(
      this.shadowRoot.getElementById("carrier-tip").value
    );

    this.totalValue = this.formatNumber(
      this.paymentAmount + this.nieDonation + this.carrierTip
    );
  }

  getExpirationMonthCode() {
    const month = this.shadowRoot.getElementById("").value;
    const selected = this.monthList.filter((item) => item.name === month);

    return selected.code;
  }

  async getRequestToken() {
    try {
      const header = {
        Authorization: `Bearer ${this.loginDetails.token}`,
      };

      const res = await axios.get(
        `${this.MainServiceDomain}/appservices/api/v2/payment/paywayws/addaccountrequesttoken`,
        {
          headers: header,
        }
      );

      return res.data;
    } catch (error) {
      return error;
    }
  }

  getName() {
    const name = this.shadowRoot
      .getElementById("name-on-card")
      .value.split(" ");
    this.firstNameOnCard = name[0];

    if (name.length > 1) {
      this.lastNameOnCard = name[name.length - 1];
    } else {
      this.lastNameOnCard = "";
    }
  }

  async onAddPaymentDetails() {
    this.paymentErrorMessage = "";
    if (this.creditCardList.length) {
      if (this.totalValue > 0) {
        this.subscriptionDetails.Status = "Inactive";
        await this.requestUpdate();
        const res = await this.getRequestToken();

        if (res.requestToken) {
          this.requestToken = res.requestToken;
          this.setProperties(false, true, false, "");
        } else {
          this.subscriptionDetails.Status = "Active";
          this.paymentErrorMessage = "Something went wrong.";
        }
      } else {
        this.paymentErrorMessage = "Please add amount";
      }
    } else {
      this.cancelPayment();
      this.paymentErrorMessage = "Something went wrong.";
    }
  }

  async paywayAddAccount() {
    try {
      const monthCode = this.monthList.find(
        (value) => value.name == this.displayMonthSelected()
      ).code;
      const yearCode = this.displayYearSelected().slice(-2);
      const headers = {
        "Content-Type": "application/json",
      };

      const body = `{
                request: "sendQueuedAddAccount",
                paywayRequestToken: "${this.requestToken}",
                accountInputMode: "primaryAccountNumber",
                cardAccount:
                  {
                    idDivision: "${this.edgilPaymentConfig.division}",
                    fsv: "${
                      this.shadowRoot.getElementById("card-security-code").value
                    }",
                    accountNumber: "${
                      this.shadowRoot.getElementById("card-number").value
                    }",
                    expirationDate: "${monthCode}/${yearCode}",
                    email: "${this.userDetails.Email}",
                    firstName: "${this.firstNameOnCard}",
                    lastName: "${this.lastNameOnCard}",
                    zip: "${this.shadowRoot.getElementById("zip-code").value}"
                  }
                }`;

      const res = await axios.post(
        `${this.edgilPaymentConfig.paywayWSEndpoint}Account/CreditCard`,
        body,
        {
          headers: headers,
        }
      );

      return res;
    } catch (error) {
      return error;
    }
  }

  async paywayAddAccountResults() {
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      const body = `{
                paywayRequestToken: "${this.requestToken}",
                request: "hostedAddAccountResults"
                }`;

      const res = await axios.post(
        `${this.edgilPaymentConfig.paywayWSEndpoint}Query/CreditCard`,
        body,
        {
          headers: headers,
        }
      );

      return res;
    } catch (error) {
      return error;
    }
  }

  getCode(id) {
    if (id === 6) {
      return this.creditCardList.find((value) => value.creditCardTypeId === 3)
        .code;
    }
    if (id === 3) {
      return this.creditCardList.find((value) => value.creditCardTypeId === 4)
        .code;
    }
    return this.creditCardList.find((value) => value.creditCardTypeId === id)
      .code;
  }

  async postOneTimePayment(data) {
    try {
      const cardCode = this.getCode(data.cardAccount.cardType);
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.loginDetails.token}`,
      };

      const body = `{
                PaymentAmount: ${this.paymentAmount},
                TipAmount: ${this.carrierTip},
                DonationAmount: ${this.nieDonation},
                Token: "${data.cardAccount.paywayToken}",
                MaskedCardNumber: "${data.cardAccount.accountNumber}",
                CardholderName: "${data.cardAccount.firstName} ${
        data.cardAccount.lastName
      }",
                CardExpirationMonth: "${data.cardAccount.expirationDate.slice(
                  0,
                  2
                )}",
                CardExpirationYear: "20${data.cardAccount.expirationDate.slice(
                  -2
                )}",
                CardTypeCode: "${cardCode}"        
            }`;

      const res = await axios.post(
        `${this.MainServiceDomain}/appservices/api/v2/subscription/${this.subscriptionDetails.SubscriptionId}/payment/onetime`,
        body,
        {
          headers: headers,
        }
      );

      return res;
    } catch (error) {
      return error;
    }
  }

  setProperties(isMakePayment, isPaymentDetails, isConfirmPayment, message) {
    if (!isPaymentDetails || isConfirmPayment) {
      this.selectedMonth = undefined;
      this.selectedYear = undefined;
    }
    this.subscriptionDetails.Status = "Active";
    this.makePayment = isMakePayment;
    this.paymentDetails = isPaymentDetails;
    this.confirmPayment = isConfirmPayment;
    this.paymentErrorMessage = message;
  }

  async onConfirmPayment() {
    if (this.shadowRoot.getElementById("name-on-card").value != "") {
      if (
        this.shadowRoot.getElementById("card-number").value != "" &&
        !this.shadowRoot.getElementById("card-number").validity.patternMismatch
      ) {
        if (this.selectedMonth != undefined && this.selectedYear != undefined) {
          this.paymentErrorMessage = "";
          this.subscriptionDetails.Status = "Inactive";
          await this.requestUpdate();
          const res = await this.paywayAddAccount();

          if (res.status === 200) {
            if (res.data.paywayCode == 5000) {
              const res1 = await this.paywayAddAccountResults();

              if (res1.status === 200) {
                if (res1.data.paywayCode == 5000) {
                  this.paywayWSAddAccountResults = res1.data;
                  if (
                    [1, 2, 3, 6].indexOf(res1.data.cardAccount.cardType) !== -1
                  ) {
                    const res2 = await this.postOneTimePayment(res1.data);
                    if (res2.status === 201) {
                      if (res2.data.authorizationCode) {
                        this.finalPaymentDetails = res2.data;
                        this.setProperties(false, true, true, "");
                        this.isPrint = true;
                      } else {
                        this.setProperties(
                          true,
                          false,
                          false,
                          res2.response.data.modelState[
                            "paymentRequest.CardExpirationMonth"
                              ? "paymentRequest.CardExpirationMonth"
                              : "paymentRequest"
                          ]
                        );
                      }
                    } else {
                      this.setProperties(
                        true,
                        false,
                        false,
                        res2["response.data.message"]
                      );
                    }
                  } else {
                    this.setProperties(
                      true,
                      false,
                      false,
                      "This type of card is not supported by us."
                    );
                  }
                } else {
                  this.setProperties(
                    true,
                    false,
                    false,
                    res1.data.paywayMessage != ""
                      ? res1.data.paywayMessage
                      : "Something went wrong. Please try again"
                  );
                }
              } else {
                this.setProperties(
                  true,
                  false,
                  false,
                  res1.response.data.errorMessage
                );
              }
            } else {
              this.subscriptionDetails.Status = "Active";
              this.paymentErrorMessage =
                res.data.paywayMessage != ""
                  ? res.data.paywayMessage
                  : "Something went wrong. Please try again";
              await this.requestUpdate();
            }
          } else {
            this.setProperties(true, false, false, res.response.data.message);
          }
        } else {
          this.paymentErrorMessage = "Please select expiration date and month";
        }
      } else {
        this.paymentErrorMessage = "Please enter 15 or 16 digit card number";
      }
    } else {
      this.paymentErrorMessage = "Please enter name on card";
    }
  }

  closeOnConfirmPayment() {
    this.cancelPayment();
    this.paymentDetails = false;
    this.confirmPayment = false;
  }

  async printReceipt() {
    await this.requestUpdate();
    if (this.ReceiptLogo) {
      const divContents =
        this.shadowRoot.getElementById("payment-info-div").innerHTML;
      const a = window.open("", "PRINT", "height=1000, width=1000");
      a.document.write("<html>");
      a.document.write("<body>");
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.close();
      a.print();
    }
  }

  onCancelConfirmPayment() {
    this.setProperties(true, false, false, "");
  }

  getAccountNumber() {
    if (this.subscriptionDetails) {
      if (
        this.subscriptionDetails.CirculationDetails.CircSystemSubscriptionId
      ) {
        return this.subscriptionDetails.CirculationDetails
          .CircSystemSubscriptionId;
      }
      return this.subscriptionDetails.SubscriptionId;
    }
    return "";
  }

  returnToNews() {
    window.open(this.newsLink, "_blank");
  }
}

customElements.define("syncui-payment", PaymentComponent);
